import classNames from "classnames";
import React from "react";

export type CardComponentProps = {
    color?: string;
    body?: boolean;
    inverse?: boolean;
    outline?: boolean;
};

export type CardProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, CardComponentProps, "div">;

const Card = React.forwardRef(
    <T extends React.ElementType = "div">(
        {
            className,
            color,
            body,
            inverse,
            outline,
            tag,
            ...attributes
        }: CardProps<T>,
        ref?: React.ForwardedRef<T>,
    ) => {
        const Tag = tag || ("div" as React.ElementType);
        const classes = classNames(
            className,
            "card",
            inverse ? "text-white" : false,
            body ? "card-body" : false,
            color ? `${outline ? "border" : "bg"}-${color}` : false,
        );

        return <Tag {...attributes} className={classes} ref={ref} />;
    },
);

export { Card };
